import React from 'react';
import { FiCheckCircle, FiXCircle } from 'react-icons/fi';

interface SuccessDisplayProps {
  message: string;
  onDismiss?: () => void;
  className?: string;
}

export const SuccessDisplay: React.FC<SuccessDisplayProps> = ({ message, onDismiss, className = '' }) => {
  return (
    <div className={`p-4 bg-green-50 border border-green-200 rounded-lg text-green-700 flex items-start gap-3 ${className}`}>
      <FiCheckCircle className="h-5 w-5 flex-shrink-0 mt-0.5" />
      <div className="flex-1">
        <p className="text-sm">{message}</p>
      </div>
      {onDismiss && (
        <button
          onClick={onDismiss}
          className="text-green-500 hover:text-green-700 transition-colors"
          aria-label="Dismiss message"
        >
          <FiXCircle className="h-5 w-5" />
        </button>
      )}
    </div>
  );
};

